import React, { useState } from 'react';
import ErrorBoundary from '../../Shared/ErrorBoundary';
import DealershipInfoS1 from './DealershipInfoS1';
import DealershipInfoS2 from './DealershipInfoS2';
import DealershipInfoS3 from './DealershipInfoS3';

const DealershipInfo = (props) => {

    const [currentStep, setCurrentStep] = useState(props.innerCurrSection ? props.innerCurrSection : 1);

    const submit = async (event, isPreviousClick = false) => {

        if (isPreviousClick && currentStep === 1) {
            props.setInnerCurrSection(1);
            props.submit(event, null, true);
        }
        else if (isPreviousClick) {
            props.setInnerCurrSection(currentStep - 1);
            setCurrentStep(currentStep - 1);
        }
        else {
            let success = await props.submit(event, currentStep, null, currentStep == 3 ? true : false);
            if (success && currentStep < 3) {
                setCurrentStep(currentStep + 1);
                props.setInnerCurrSection(currentStep + 1);
            }
        }

    }

    let component = null;

    switch (currentStep) {

        case 1:
            component = <ErrorBoundary><DealershipInfoS1 formData={props.dealershipInfoS1Details} twoWayBind={(key, value) => props.twoWayBind(key, value, 1)} submitForm={(event, isPreviousClick = false) => submit(event, isPreviousClick)} /></ErrorBoundary>;
            break;
        case 2:
            component = <ErrorBoundary><DealershipInfoS2 formData={props.dealershipInfoS2Details} twoWayBind={(key, value) => props.twoWayBind(key, value, 2)} resetLeaseData={props.resetLeaseData} submitForm={(event, isPreviousClick = false) => submit(event, isPreviousClick)} /></ErrorBoundary>;
            break;
        case 3:
            component = <ErrorBoundary><DealershipInfoS3 formData={props.dealershipInfoS3Details} twoWayBind={(key, value) => props.twoWayBind(key, value, 3)} submitForm={(event, isPreviousClick = false) => submit(event, isPreviousClick)} /></ErrorBoundary>;
            break;
        default:
            break;

    }

    return (
        <React.Fragment>
            {/* <h2 className="my-3 formHeading-text font_weight_700 marginLeft-6px">Dealership Info</h2> */}
            {component}
        </React.Fragment>
    )
}

export default DealershipInfo;